export function isMobile(phone) {
    return /^1(2|3|4|5|6|7|8|9)\d{9}$/.test(phone);
}

export const uncompileStr = (code) => {
    code = unescape(code);
    var c = String.fromCharCode(code.charCodeAt(0) - code.length);
    for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
    }
    return c;
};
